import ContactUsButton from "../../components/contact-us-button";
import './career-widget-section.css';

const CareerSection = (props) => {
  return <div className="career-widget">
    <div className="career-wrapper">
      <div className="career-image">
        <img {...props.image} alt="careers" loading="lazy" />
      </div>
      <div className="career-overview">
        <div className="title">{props.details.title}</div>
        <div className="subtitle">
          {props.details.subtitle.map(text => <div key={text} className="text">{text}</div>)}
        </div>
        <div className="description">
          {props.details.description.map(text => <div key={text} className="text">{text}</div>)}
        </div>
        <div className="bullet-points">
          <div className="bullet-title">{props.details.bulletPoints.title}</div>
          {props.details.bulletPoints.list.map(item => {
            return <div key={item.title} className="bullet-point">
              <img src={item.icon} alt="bullet-point-icon" loading="lazy" />
              <div className="bullet-text">{item.title}</div>
            </div>
          })}
        </div>
        <ContactUsButton {...props.details.detailButton} linkClassName="career-contact" />
      </div>
    </div>
  </div>
};

export default CareerSection;